import { patchSubmission } from 'api/submissions';
import { IPatchObject } from 'interfaces/request';
import { SubmissionStatus } from 'interfaces/submissions';
import {
  displayErrorArrayNotifications,
  displaySuccessNotification,
} from 'modules/Notifications';
import { useMutationWithResultNotification } from '../useMutationWithResultNotification';

type ModifySubmissionsStatusParams = {
  submissionId: string;
  status: SubmissionStatus;
};

function useModifySubmissionStatus(
  organizationId: string,
  onSuccess?: () => void
) {
  return useMutationWithResultNotification({
    asyncApiFunction: async ({
      submissionId,
      status,
    }: ModifySubmissionsStatusParams) => {
      const patchObject: IPatchObject[] = [
        {
          op: 'replace',
          path: '/status',
          value: status,
        },
      ];

      await patchSubmission(organizationId, submissionId, patchObject);
    },
    onSuccess: () => {
      displaySuccessNotification('Projects.submissionStatusChangeSuccess');
      onSuccess && onSuccess();
    },
    onErrorArray: (errorArray) => {
      displayErrorArrayNotifications(
        errorArray,
        'Projects.submissionStatusChangeErrors'
      );
    },
    resetOnResult: true,
  });
}

export default useModifySubmissionStatus;
